module.exports = __webpack_public_path__ + "media/images/writer-offering-merit03-41f4828b133430c9bd54b44aa1e6a8d3.png";